<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.paciente"
        :disabled-button-search="true"
        ref="DataTable"
        search-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <slot
                name="actions"
                v-bind:item="item"
            >
            </slot>
        </template>

        <template v-slot:cell(dataNascimento)="row">
            {{ row.value | formatDate }}
        </template>

        <template v-slot:cell(cpf)="row">
            {{ row.value | formatCpf }}
        </template>

        <template v-slot:cell(cns)="row">
            {{ row.value | formatCns }}
        </template>
    </rkm-data-table>
</template>

<script>
import { repository, error } from '@/mixins'
import formats from '@/filters/formats'
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    computed: {
        fields() {
            return [
                {
                    key: 'prontuario',
                    name: 'cadastro_paciente.prontuario',
                    label: 'Prontuário',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nome',
                    name: 'cadastro_cidadao.nome',
                    label: 'Nome',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'nomeMae',
                    name: 'cadastro_cidadao.nome_mae',
                    label: 'Nome da Mãe',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'dataNascimento',
                    name: 'cadastro_cidadao.data_nascimento',
                    label: 'Data de nascimento',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cns',
                    name: 'cadastro_cidadao.cns',
                    label: 'CNS',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'cpf',
                    name: 'cadastro_cidadao.cpf',
                    label: 'CPF',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
    },
    filters: {
        formatDate: formats.formatDate,
        formatCns: formats.formatCns,
        formatCpf: formats.formatCpf,
    },
    mixins: [ repository, error ]
}
</script>